import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	maxLengthError: {
		id: 'polaris-lib-create-issue-input.max-length-error',
		defaultMessage: "Summary can't exceed 255 characters.",
		description: 'Error message if short text field value is too long',
	},
});
